export default {"src":"/_next/static/image/public/images/flags/flag_56.6ee95894dce8f851a763914e9eed306f.svg","height":16,"width":25};